import { API } from "@/services"

export const CREDENTIALS_ENDPOINTS = {
  create(data={}){
    return API.Axios.automation.v1.request({
      url: `credentials`,
      method: 'POST',
      data,
    })
  },
  list(params={}){
    return API.Axios.automation.v1.request({
      url: `credentials`,
      method: 'GET',
      params,
    })
  },
  search(params={}){
    return API.Axios.automation.v1.request({
      url: `credentials/search`,
      method: 'GET',
      params,
    })
  },
  startLoudBalance(data={}){
    return API.Axios.automation.v1.request({
      url: `credentials/loud-balance`,
      method: 'POST',
      data,
    })
  },
  stopLoudBalance(taskName='',data={}){
    return API.Axios.automation.v1.request({
      url: `credentials/loud-balance/${taskName}`,
      method: 'DELETE',
      data,
    })
  },
  findById(id='',params={}){
    return API.Axios.automation.v1.request({
      url: `credentials/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={}){
    return API.Axios.automation.v1.request({
      url: `credentials/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(id='',data={}){
    return API.Axios.automation.v1.request({
      url: `credentials/${id}`,
      method: 'PUT',
      data,
    })
  },
}